/**
 * The "N helpers are still working. Stop them too?" ask (D11), keyed to the
 * task it was raised FOR, never a bare boolean: it is a destructive control,
 * and a boolean follows you to the next task, where "Stop them" would fan an
 * interrupt at lanes the person never saw.
 *
 * A store and not the task layout's state (plan ruling P-5): with
 * one-composer-everywhere on, Stop lives in the Dock's pill and HelpersBar
 * stays in the task layout, two trees with no common parent below the app
 * shell. The LAYOUT still owns the ask's lifetime (it forgets it on a task
 * change, when the last helper reports, and on unmount); this only holds it.
 */
import { create } from "zustand";

interface TaskStopPromptStore {
  /** The task the ask was raised for, or null. */
  stopPromptFor: string | null;
  raise: (taskId: string | null) => void;
  dismiss: () => void;
}

export const useTaskStopPromptStore = create<TaskStopPromptStore>((set) => ({
  stopPromptFor: null,
  raise: (taskId) => {
    if (taskId) set({ stopPromptFor: taskId });
  },
  dismiss: () =>
    set((s) => (s.stopPromptFor === null ? s : { stopPromptFor: null })),
}));
